import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = ({ children }) => {
  const userInfo = useSelector(state => state.userState.userInfo)
  const navigate = useNavigate()

  useEffect(() => {
    if (!userInfo) {
      navigate('/login')
    }
  }, [userInfo])

  return (
    <>{children}</>
  )
}

export default PrivateRoute